// ─────────────────────────────────────────────────────────────────
// PROCESS TREE DATA
// Defines: parallel groups, prerequisites, section metadata
// Used by: ProcessTree component, WizardZone enhanced suggestions
// ─────────────────────────────────────────────────────────────────

export const PROCESS_META = {
  '0.1': { parallel: [],           prerequisites: [],                    critical: true,  color: '#1F4E79' },
  '0.2': { parallel: ['0.3'],      prerequisites: ['0.1'],               critical: true,  color: '#1F4E79' },
  '0.3': { parallel: ['0.2'],      prerequisites: ['0.1'],               critical: true,  color: '#1F4E79' },
  '1.1': { parallel: [],           prerequisites: ['0.1','0.2','0.3'],   critical: true,  color: '#2E75B6' },
  '1.2': { parallel: [],           prerequisites: ['1.1'],               critical: true,  color: '#2E75B6' },
  '1.3': { parallel: ['2.1'],      prerequisites: ['1.2'],               critical: false, color: '#2E75B6' },
  '2.1': { parallel: ['1.3'],      prerequisites: ['1.2'],               critical: true,  color: '#375623' },
  '2.2': { parallel: [],           prerequisites: ['2.1'],               critical: true,  color: '#375623' },
  '3.1': { parallel: ['3.4'],      prerequisites: ['2.2'],               critical: true,  color: '#7B3F00' },
  '3.2': { parallel: ['3.3','3.4'],prerequisites: ['3.1'],               critical: true,  color: '#7B3F00' },
  '3.3': { parallel: ['3.2','3.4'],prerequisites: ['3.1'],               critical: true,  color: '#7B3F00' },
  '3.4': { parallel: ['3.1','3.2','3.3'], prerequisites: ['2.2'],        critical: false, color: '#7B3F00' },
  '4.1': { parallel: ['4.2'],      prerequisites: ['3.2','3.3'],         critical: true,  color: '#1B4F72' },
  '4.2': { parallel: ['4.1'],      prerequisites: ['3.2','3.3'],         critical: false, color: '#1B4F72' },
  '5.1': { parallel: [],           prerequisites: ['4.1','4.2'],         critical: true,  color: '#4A235A' },
  '5.2': { parallel: ['5.3'],      prerequisites: ['5.1'],               critical: true,  color: '#4A235A' },
  '5.3': { parallel: ['5.2'],      prerequisites: ['5.1'],               critical: false, color: '#4A235A' },
  '6.1': { parallel: ['6.2'],      prerequisites: ['5.2','5.3'],         critical: true,  color: '#922B21' },
  '6.2': { parallel: ['6.1'],      prerequisites: ['5.2','5.3'],         critical: false, color: '#922B21' },
  '7.1': { parallel: ['7.2'],      prerequisites: ['6.1','6.2'],         critical: true,  color: '#374151' },
  '7.2': { parallel: ['7.1','7.3'],prerequisites: ['6.1','6.2'],         critical: false, color: '#374151' },
  '7.3': { parallel: ['7.2'],      prerequisites: ['7.1','7.2'],         critical: false, color: '#374151' },
  'X.1': { parallel: ['X.2','X.3'],prerequisites: [],                    critical: true,  color: '#555555' },
  'X.2': { parallel: ['X.1','X.3'],prerequisites: [],                    critical: true,  color: '#555555' },
  'X.3': { parallel: ['X.1','X.2'],prerequisites: [],                    critical: true,  color: '#555555' },
};

// Phase-level tree nodes
export const PHASE_TREE = [
  {
    id: 'P0', label: 'Project Initiation',  color: '#1F4E79',
    sections: ['0.1','0.2','0.3'],
    parallelGroups: [['0.2','0.3']],
  },
  {
    id: 'P1', label: 'Requirements',        color: '#2E75B6',
    sections: ['1.1','1.2','1.3'],
    parallelGroups: [],
  },
  {
    id: 'P2', label: 'Solution Design',     color: '#375623',
    sections: ['2.1','2.2'],
    parallelGroups: [['1.3','2.1']],
  },
  {
    id: 'P3', label: 'Development',         color: '#7B3F00',
    sections: ['3.1','3.2','3.3','3.4'],
    parallelGroups: [['3.1','3.4'],['3.2','3.3','3.4']],
  },
  {
    id: 'P4', label: 'Testing / QA',        color: '#1B4F72',
    sections: ['4.1','4.2'],
    parallelGroups: [['4.1','4.2']],
  },
  {
    id: 'P5', label: 'UAT',                 color: '#4A235A',
    sections: ['5.1','5.2','5.3'],
    parallelGroups: [['5.2','5.3']],
  },
  {
    id: 'P6', label: 'Deployment',          color: '#922B21',
    sections: ['6.1','6.2'],
    parallelGroups: [['6.1','6.2']],
  },
  {
    id: 'P7', label: 'Project Closure',     color: '#374151',
    sections: ['7.1','7.2','7.3'],
    parallelGroups: [['7.1','7.2'],['7.2','7.3']],
  },
  {
    id: 'CX', label: 'Cross-Cutting',       color: '#555555',
    sections: ['X.1','X.2','X.3'],
    parallelGroups: [['X.1','X.2','X.3']],
  },
];
